import React from "react";
import "./StandardInstruction.css";

function StandardInstruction({ 
  id,
  title,
  icon,
  tools = [],
  steps = [],
  intro = null,
  note = null,
  customContent = null
}) {
  return (
    <div id={id} className="standard-instruction">
      <h3 className="standard-instruction-title">
        {icon && <span className="standard-instruction-icon">{icon}</span>}
        <span className="standard-instruction-title-text">{title}</span>
      </h3>
      
      <div className="standard-instruction-content">
        {/* Tools & Materials - Always First */}
        {tools && tools.items && tools.items.length > 0 && (
          <div className="standard-tools-section">
            <h4 className="standard-subsection-title">
              {tools.title || "Tools & Materials"}
            </h4>
            <ul className="standard-tools-list">
              {tools.items.map((tool, index) => (
                <li key={index}>{tool}</li>
              ))}
            </ul>
          </div>
        )}
        
        {/* Intro/Description - After Tools */}
        {intro && (
          <div className="standard-intro">
            {typeof intro === 'string' ? <p>{intro}</p> : intro}
          </div>
        )}
        
        {/* Custom Content - For special cases like video links, etc */}
        {customContent && (
          <div className="standard-custom-content">
            {customContent}
          </div>
        )}
        
        {/* Steps - After Intro */}
        {steps && steps.items && steps.items.length > 0 && (
          <div className="standard-steps-section">
            <h4 className="standard-subsection-title">
              {steps.title || "Steps"}
            </h4>
            <ol className="standard-steps-list">
              {steps.items.map((step, index) => {
                const stepContent = typeof step === 'string' ? step : step?.content;
                const stepChildren = step && typeof step === 'object' && step.children;
                
                return (
                  <li key={index}>
                    {stepContent}
                    {stepChildren && <div className="step-children">{stepChildren}</div>}
                  </li>
                );
              })}
            </ol>
          </div>
        )}
        
        {/* Note - At the End */}
        {note && (
          <div className="standard-note">
            <strong>{note.label || "Note"}:</strong> {note.text}
          </div>
        )}
      </div>
    </div>
  );
}

export default StandardInstruction;

